import ConsumerPreviewCard from './ConsumerPreviewCard';

export default ConsumerPreviewCard;
